import { forwardRef } from "react"
import type { TextareaHTMLAttributes } from "react"
import { cn } from "@/lib/cn"

// Multi-line text input. Mirrors Input's styling so forms feel consistent.
type Props = TextareaHTMLAttributes<HTMLTextAreaElement>

// Mirrors Input. `rounded-xl` per the prototype; min-height stays at the
// existing flow so multi-line content surfaces still expand naturally.
// Touch targets aren't the constraint here — long-form text input is the
// constraint, so width and line-height matter more than height.
export const Textarea = forwardRef<HTMLTextAreaElement, Props>(function Textarea({ className, ...rest }, ref) {
  return (
    <textarea
      ref={ref}
      {...rest}
      className={cn(
        "w-full resize-none rounded-xl border border-border bg-white/5 px-4 py-3 text-sm text-app-text",
        "placeholder:text-app-subtle outline-none transition focus:border-brand-red/50 focus:shadow-[0_0_0_3px_var(--brand-red-soft)]",
        "disabled:opacity-50 disabled:pointer-events-none",
        className,
      )}
    />
  )
})
